"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadFeefoScript = void 0;
const ScriptLoaderUtil_1 = require("./ScriptLoaderUtil");
const ReviewConstants_1 = require("../constants/ReviewConstants");
const loadFeefoScript = (feefoIdentifier) => {
    ScriptLoaderUtil_1.default.loadScript(`https://api.feefo.com/api/javascript/${feefoIdentifier}`, ReviewConstants_1.FEEFO_POPUP_SCRIPT_ID);
};
exports.loadFeefoScript = loadFeefoScript;
